<app-page-layout>
  <div class="text-center mt-70">
    <img src="../../../../../assets/images/loading.png" />
    <nz-row style="justify-content: center" class="mt-40 f-14">
      {{ loadFailed ? 'Could not load your workspace.' : 'Loading your experience...' }}
    </nz-row>
    <nz-row *ngIf="loadFailed" class="mt-12 f-12" style="justify-content: center; color: #8c8c8c;">
      Check your connection and try again.
    </nz-row>
    <nz-row *ngIf="loadFailed" style="justify-content: center; gap: 12px;" class="mt-24">
      <button nz-button nzType="primary" [disabled]="isBootstrapping" (click)="retryBootstrap()">
        Retry
      </button>
      <button nz-button nzType="default" (click)="manualLogout()">
        Logout
      </button>
    </nz-row>
    <nz-row *ngIf="!loadFailed && canShowManualLogout()" style="justify-content: center" class="mt-24">
      <button nz-button nzType="default" (click)="manualLogout()">
        Logout
      </button>
    </nz-row>
  </div>
</app-page-layout>
